<!--
  navItem "Komponenten-Eignung" — the rule set that decides, per commission component, whether that
  component is settled at all (K-18, 01-requirement.md §6).

  The table is the generic child table; the only addition is the pre-filter on the commission
  component, for the same reason the Matrix-Zuordnung and the Berechnete-Vermittler tabs carry one:
  the mandatory component partitions the rule set. The pre-filter is a READ aid — it narrows the
  list and does not change how rows are created; the create form still pre-fills the provision type
  and lets the user pick the component.

  The legend below the filter states the two properties that INVERT what the four sibling
  assignment tables have taught the caseworker (BR-1, BR-2, §12.7): the absence of a row means
  eligible, and the verdict is formed per former contract rather than per contract. Both are stated
  once here instead of guessed per row.

  No nested <ng-template #content> anywhere in this file: inside PrimeNG projected content that name
  is reserved and would replace the host's whole body.
-->
<div class="cp-provision-type-component-eligibility">

    @if (initialized && provisionTypeId) {

        @if (componentOptions.length) {
            <div class="flex align-items-center flex-wrap gap-2 mb-3">
                <i class="fa-solid fa-filter text-color-secondary"></i>
                <label for="cpComponentEligibilityComponentFilter" class="text-sm text-color-secondary">
                    Provisionsart
                </label>
                <p-select
                        inputId="cpComponentEligibilityComponentFilter"
                        styleClass="w-16rem"
                        [options]="componentOptions"
                        optionLabel="name"
                        optionValue="id"
                        [ngModel]="selectedComponentId"
                        (ngModelChange)="onComponentChange($event)"
                        [showClear]="true"
                        placeholder="Alle Provisionsarten">
                </p-select>
                <span class="text-sm text-color-secondary">
                    Zeigt nur die Eignungsregeln der gewählten Provisionsart — die vollständige
                    Zeile wird im Detail-Dialog gepflegt.
                </span>
            </div>
        }

        <!--
          Evaluation semantics. K-18 is the only assignment family whose ABSENCE is a decision, and
          the only one evaluated per former contract; both facts change how a rule set has to be
          read, so they are stated above the table.
        -->
        <div class="flex align-items-start gap-2 mb-3">
            <i class="fa-solid fa-circle-info text-color-secondary mt-1"></i>
            <span class="text-sm text-color-secondary">
                Wird je Vorvertrag ausgewertet, nach der Vertrags-Eignung.
                <strong>Keine Zeile ⇒ Komponente ist relevant.</strong>
                Die Vertrags-Eignung („Relevanz") läuft zuerst und typweit; nur wenn sie „Relevant"
                ergibt, wird hier je Provisionsart geprüft — vor der Basiswert- und der
                Matrix-Zuordnung. Es gewinnt die erste zutreffende Zeile nach Reihenfolge; eine Zeile
                ohne Bedingungssatz gilt für <strong>alle Verträge</strong>. „Nicht relevant" überspringt die Provisionsart
                still: kein Anspruch, keine Buchung, nur ein Eintrag in der Berechnungsspur.
                Es genügt <strong>ein</strong> geeigneter Vorvertrag: nur wenn <strong>alle</strong>
                Vorverträge „Nicht relevant" ergeben, wird die Provisionsart übersprungen.
                „Gesellschaft Vorvertrag" und „Laufzeit Vorvertrag" in den Bedingungen beziehen sich
                hier auf den <strong>jeweils geprüften</strong> Vorvertrag — in den anderen
                Zuordnungstabellen dagegen allein auf den Haupt-Vorvertrag.
            </span>
        </div>

        <cp-provision-type-child-table
                [provisionTypeId]="provisionTypeId"
                [child]="child"
                [additionalFilters]="additionalFilters"
                (onJumpToConditionSet)="onJumpToConditionSet.emit($event)">
        </cp-provision-type-child-table>

    } @else if (initialized) {
        <p-message severity="info" text="Kein Provisionstyp ausgewählt." styleClass="w-full"></p-message>
    } @else {
        <p-skeleton height="12rem"></p-skeleton>
    }

</div>
